<template>
    <Button @click="$emit('click')"
        :icon="icon"
        :text="text"
        emphasis="high"
    />
</template>

<script>
import { Button } from '@sportsrecruits/playbook'

export default {
    components: { Button },

    props: {
        text: { type: String, required: true },
        icon: { type: String, required: true },
    },
}
</script>